import React, { Component } from 'react';
import { get, has } from "lodash"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import StepControl from "../stepControl"
import { sexData } from "../sex/static.sexData"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { steps } from "../../../shared/static.steps"
import locales from "../../../content.json";
import ButtonFill from "../../../shared/items/controls/buttonFill"
import getParameterFromURL from "../../../utils/getParameterFromUrl"
import styles from './firstPageQuestionD.module.scss'
import "../../../shared/services/service.step.scss"
import store from '../../../store'

import plan from "./img/plan.png"
class FirstPageQuestionD extends Component {
  constructor() {
    super();

    this.state = {
      isOpenFirstPageQuestionD: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.firstPageQuestionDFirstPageQuestionD) && !this.state.isOpenFirstPageQuestionD)
      this.setState({ isOpenFirstPageQuestionD: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenFirstPageQuestionD } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.firstPageQuestionDFirstPageQuestionD,
      isOpen: isOpenFirstPageQuestionD,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenFirstPageQuestionD && !has(data, ["firstPageQuestionDFirstPageQuestionD"]))
      onSetStepData("firstPageQuestionDFirstPageQuestionD")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenFirstPageQuestionD: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenFirstPageQuestionD } = this.state
    let ageAbtest = store.getState().appState.isAgeAbtest;
    let ageManTest = store.getState().appState.isAgeManTest;
    const params = {
      className: "firstPageQuestionD",
      currentIndex: currentIndex,
      stepIndex: steps.firstPageQuestionD,
    }

    return (
      <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
        <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
            <div className={styles.questionD_container}>
              <div 
                className={styles.title} 
                dangerouslySetInnerHTML={{__html: locales[window.userLang].firstQuestionD_title}}>
              </div>
              <div 
                className={styles.description} 
                dangerouslySetInnerHTML={{__html: locales[window.userLang].firstQuestionD_description_top}}>
              </div>
              <img className={styles.plan} src={plan} alt="plan"/>
              <div className={styles.description_bottom} >
                {locales[window.userLang].firstQuestionD_description_bottom}
              </div>
                <div className={styles.genderButton_choice} onClick={() => {
                  ageAbtest && onUpdateStepData.bind(this, "sex", "value", "female")();
                  ageManTest && onUpdateStepData.bind(this, "sex", "value", "male")();
                  this.props.onToNextStep()
                }}>
                  {locales[window.userLang].firstQuestionD_button_no}
                </div>
                <div className={styles.genderButton_choice_active} onClick={() => {
                  ageAbtest && onUpdateStepData.bind(this, "sex", "value", "female")();
                  ageManTest && onUpdateStepData.bind(this, "sex", "value", "male")();
                  this.props.onToNextStep()
                }}>
                  {locales[window.userLang].firstQuestionD_button_yes}
                </div>
            </div>
        </div>
      </div>
    )
  }
}

export default withStepsState(FirstPageQuestionD);